import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { referralToHospitalDraftSchema } from './referralToHospital.draft';
import { ReferralToHospitalFormBean } from './ReferralToHsopitalForm/ReferralToHospitalForm.types';

type ReferralToHospitalPanelLoaderChildrenProps = {
   referralToHospitalDraft: ReferralToHospitalFormBean | null;
};
type ReferralToHospitalPanelLoaderProps = {
   readonly children: ({ referralToHospitalDraft }: ReferralToHospitalPanelLoaderChildrenProps) => JSX.Element;
   readonly visitId: number;
   readonly electronic: boolean;
};

export const ReferralToHospitalPanelLoader = (props: ReferralToHospitalPanelLoaderProps): JSX.Element => {
   const {
      data: referralToHospitalDraft,
      loading: referralToHospitalDraftLoading,
      error: referralToHospitalDraftError,
   } = useDraftCqrsFind(
      {
         token: getReferralDraftToken(
            props.electronic ? 'electronicReferralToHospital' : 'referralToHospital',
            props.visitId
         ),
      },
      referralToHospitalDraftSchema
   );

   if (referralToHospitalDraftLoading) {
      return <LoaderSpinner />;
   }

   if (referralToHospitalDraftError) {
      return (
         <Message
            testId={'referralToHospitalFetchError'}
            type={MessageType.NEGATIVE}
            label={referralTranslationKeys.referralFetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      referralToHospitalDraft: referralToHospitalDraft?.contents ?? null,
   });
};
